export const DASHBOARD_DATE_FILTER_PERIODS = {
  ALL: "all",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
  CUSTOM: "custom",
};

export const formatDateParam = (date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getDashboardDateRange = (
  period,
  customDateFrom = null,
  customDateTo = null
) => {
  switch (period) {
    case DASHBOARD_DATE_FILTER_PERIODS.WEEK: {
      const today = new Date();
      const dateFrom = new Date(today);
      dateFrom.setDate(today.getDate() - 7);

      return {
        dateFrom,
        dateTo: today,
      };
    }
    case DASHBOARD_DATE_FILTER_PERIODS.MONTH: {
      const today = new Date();
      const dateFrom = new Date(today);
      dateFrom.setDate(today.getDate() - 30);

      return {
        dateFrom,
        dateTo: today,
      };
    }
    case DASHBOARD_DATE_FILTER_PERIODS.YEAR: {
      const today = new Date();
      const dateFrom = new Date(today);
      dateFrom.setDate(today.getDate() - 365);

      return {
        dateFrom,
        dateTo: today,
      };
    }
    case DASHBOARD_DATE_FILTER_PERIODS.CUSTOM:
      return {
        dateFrom: customDateFrom,
        dateTo: customDateTo,
      };
    case DASHBOARD_DATE_FILTER_PERIODS.ALL:
    default:
      return {
        dateFrom: null,
        dateTo: null,
      };
  }
};

export const getDashboardFilterParams = (dateFilter) => {
  const range = getDashboardDateRange(
    dateFilter?.period,
    dateFilter?.customDateFrom,
    dateFilter?.customDateTo
  );

  return {
    dateFrom: range.dateFrom ? formatDateParam(range.dateFrom) : null,
    dateTo: range.dateTo ? formatDateParam(range.dateTo) : null,
  };
};

/**
 * Determines whether monthly endpoints should be used instead of weekly ones.
 * Monthly endpoints are used when the queried date range exceeds 58 days.
 */
export const shouldUseMonthlyEndpoint = (dateFilter) => {
  const range = getDashboardDateRange(
    dateFilter?.period,
    dateFilter?.customDateFrom,
    dateFilter?.customDateTo
  );

  if (!range.dateFrom || !range.dateTo) {
    // For "All" period (no dates), default to monthly for broader data
    return dateFilter?.period === DASHBOARD_DATE_FILTER_PERIODS.ALL;
  }

  const diffTime = Math.abs(range.dateTo - range.dateFrom);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 58;
};